export const iconFontAwesomeShoppingTrophy = (
	<i className="fa-solid fa-trophy"></i>
);
